<template>
    <div
        style="display: contents;"
    >
        <tr
            class="kgr-table__row"
            :class="{'is-striped': isStriped}"
            @click="toggleActive"
        >
            <td
                class="kgr-table__cell"
                :class="{'kgr-clickable': node.isDirectory}"
            >
                <div
                    :class="treeClass"
                >
                    <div
                        class="kgr-tree__header"
                    >
                        <div class="kgr-tree__headerIconWrapper">
                            <kgr-icon
                                :disabled="!node.isDirectory"
                                :icon-class="iconClass"
                                small
                                accent
                            />
                        </div>
                        <div class="kgr-tree__headerContent">
                            <div
                                class="kgr-text--truncated"
                                style="max-width: 400px"
                            >
                                {{ node.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </td>
            <td class="kgr-table__cell">
                {{ createdDate }}
            </td>
            <td class="kgr-table__cell">
                {{ updatedDate }}
            </td>
            <td class="kgr-table__cell">
                {{ node.description }}
            </td>
            <td class="kgr-table__cell">
                <a
                    v-if="node.downloadUrl"
                    :href="node.downloadUrl"
                >
                    <kgr-icon
                        icon-class="save"
                        small
                        accent
                    />
                </a>
            </td>
        </tr>
        <kgr-file-table-tree
            v-for="(child, index) in node.childNodes"
            v-show="active"
            :key="child.id"
            :node="child"
            :active-nodes="activeNodes"
            :level="level + 1"
            :is-striped="!isStriped || index % 2 !== 0"
            @addActive="$emit('addActive', $event)"
            @removeActive="$emit('removeActive', $event)"
        />
    </div>
</template>

<script>
import { format, parseISO } from '@legacy/js/date/date-fns.js'
import Icon from '../icon/Icon';
import Node from '../../../js/dto/Node.js';
export default {
    name: 'KgrFileTableTree',
    components: {
        'kgr-icon': Icon,
    },
    props: {
        node: {
            type: Node,
            required: true,
        },
        level: {
            type: Number,
            required: false,
            default: 0
        },
        isStriped: {
            type: Boolean,
            required: false,
            default: false
        },
        activeNodes: {
            type: Array,
            required: true,
        },
    },

    computed: {
        treeClass() {
            return `kgr-tree kgr-tree--level-${this.level}`;
        },
        iconClass() {
            if(this.node.isDirectory) {
                return 'folder-shared';
            }
            return 'file';
        },
        updatedDate() {
            return format(parseISO(this.node.updated), 'dd.MM.yyyy HH:mm');
        },
        createdDate() {
            return format(parseISO(this.node.created), 'dd.MM.yyyy HH:mm');
        },
        active() {
            return this.activeNodes.indexOf(this.node.id) !== -1;
        }
    },
    methods: {
        toggleActive() {
            if(!this.node.isDirectory) {
                return;
            }
            if(this.active) {
                this.$emit('removeActive', this.node.id);
            } else {
                this.$emit('addActive', this.node.id);
            }

        }
    },
}
</script>
